import { render, staticRenderFns } from "./SectionRosterCard.vue?vue&type=template&id=3c94c06e&scoped=true"
import script from "./SectionRosterCard.vue?vue&type=script&lang=js"
export * from "./SectionRosterCard.vue?vue&type=script&lang=js"
import style0 from "./SectionRosterCard.vue?vue&type=style&index=0&id=3c94c06e&prod&scoped=true&lang=scss"
import style1 from "./SectionRosterCard.vue?vue&type=style&index=1&id=3c94c06e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94c06e",
  null
  
)

export default component.exports